import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { StatusScheduling } from 'src/app/shared/services/models/medical-record/status-scheduling.model';

@Component({
    selector: 'app-subtitle-info',
    templateUrl: './subtitle-info.component.html',
    styleUrls: ['./subtitle-info.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SubtitleInfoComponent implements OnInit {

  @Input() listStatusScheduling: StatusScheduling[];

  constructor() { }

  ngOnInit(): void { }

}
